import React, { ReactNode, FunctionComponent } from 'react';
import { IconButton } from '../../IconButton/IconButton';
import { SKIN_PRIORITY_MAP } from '../constants';

type ControlProps = {
  dataHook?: string;
  className?: string;
  onClick: () => void;
  icon: ReactNode;
  size?: string;
  skin?: keyof typeof SKIN_PRIORITY_MAP;
  disabled?: boolean;
};

const Control: FunctionComponent<ControlProps> = ({
  dataHook,
  className,
  onClick,
  icon,
  size,
  skin = 'standard',
  disabled = false,
}) => (
  <IconButton
    dataHook={dataHook}
    className={className}
    onClick={onClick}
    size={size}
    skin={skin}
    disabled={disabled}
    priority={SKIN_PRIORITY_MAP[skin]}
  >
    {icon}
  </IconButton>
);

export { Control };
